import { accountApi as apiService } from './api';

class UsageService {
  async getUsage() {
    try {
      const response = await apiService.request('/billing/info?detailed=true');
      return response;
    } catch (error) {
      console.error('Error fetching usage:', error);
      return {
        plan: 'open_source',
        limits: { analyses: 30, videoVerifications: 10 },
        periodStart: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
        periodEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(),
        analysesUsed: 0,
        analyses: [],
      };
    }
  }
}

const usageService = new UsageService();
export default usageService;
